var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("PageHeader", {
        attrs: {
          title: "Manage Service Configurations",
          icon: "settings",
          subtitle: _vm.description,
        },
      }),
      _vm._v(" "),
      _c("Subheader", {
        attrs: { title: "Service Configurations", search: "configurations" },
        model: {
          value: _vm.search,
          callback: function ($$v) {
            _vm.search = $$v
          },
          expression: "search",
        },
      }),
      _vm._v(" "),
      _vm._l(_vm.filteredConfigurations, function (configuration) {
        return _c(
          "v-card",
          { key: configuration.id, staticClass: "mb-1 configuration-card" },
          [
            _c("v-card-title", { staticStyle: { padding: "10px" } }, [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(configuration.name)),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "v-card-actions",
              [
                _c("ViewDialog", {
                  attrs: { form: _vm.form, configuration: configuration },
                  on: {
                    fetchConfigurations: function ($event) {
                      return _vm.$emit("fetchConfigurations")
                    },
                  },
                }),
                _vm._v(" "),
                _c("ScheduleDialog", {
                  attrs: { form: _vm.form, configuration: configuration },
                  on: {
                    fetchConfigurations: function ($event) {
                      return _vm.$emit("fetchConfigurations")
                    },
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.configurations.length == 0
        ? _c("v-container", [
            _c(
              "p",
              [
                _c(
                  "v-icon",
                  {
                    staticClass: "pr-2",
                    staticStyle: { "line-height": "19px" },
                    attrs: { color: "info" },
                  },
                  [_vm._v("error_outline")]
                ),
                _vm._v(
                  "This place is empty.\n      Create a configuration and it will show up here!\n    "
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }